import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'HtmlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-html",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13 16v-8l2 5l2 -5v8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M1 16v-8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 8v8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M1 12h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 8h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 8v8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 8v8h3"
    }, null), _createTextVNode(" ")]);
  }
};